const BANNER_WINDOW_DAYS = 7;

// Records the calendar day the nudge banner first became eligible to show for this user,
// so we can stop showing it once BANNER_WINDOW_DAYS have passed, even if onboarding is
// still incomplete.
const ONBOARDING_BANNER_FIRST_SHOWN_KEY_PREFIX = "sb_onboarding_banner_first_shown_";

// Records the last calendar day the user closed the banner. Dismissal only lasts for that
// day — the banner reappears the next time they visit on a later day.
const ONBOARDING_BANNER_DISMISSED_DATE_KEY_PREFIX = "sb_onboarding_banner_dismissed_date_";

function todayDateString(): string {
  return new Date().toISOString().slice(0, 10);
}

export function getOnboardingBannerFirstShownDate(userId: string): string | null {
  if (typeof window === "undefined" || !userId) return null;
  try {
    return window.localStorage.getItem(ONBOARDING_BANNER_FIRST_SHOWN_KEY_PREFIX + userId);
  } catch (error) {
    console.warn("Failed to read onboarding banner first-shown date:", error);
    return null;
  }
}

export function markOnboardingBannerFirstShown(userId: string): void {
  if (typeof window === "undefined" || !userId) return;
  if (getOnboardingBannerFirstShownDate(userId)) return;
  try {
    window.localStorage.setItem(
      ONBOARDING_BANNER_FIRST_SHOWN_KEY_PREFIX + userId,
      todayDateString()
    );
  } catch (error) {
    console.warn("Failed to persist onboarding banner first-shown date:", error);
  }
}

export function isOnboardingBannerWindowExpired(userId: string): boolean {
  const firstShown = getOnboardingBannerFirstShownDate(userId);
  if (!firstShown) return false;
  const daysElapsed = (Date.parse(todayDateString()) - Date.parse(firstShown)) / 86_400_000;
  return daysElapsed >= BANNER_WINDOW_DAYS;
}

export function isOnboardingBannerDismissedToday(userId: string): boolean {
  if (typeof window === "undefined" || !userId) return false;
  try {
    return (
      window.localStorage.getItem(ONBOARDING_BANNER_DISMISSED_DATE_KEY_PREFIX + userId) ===
      todayDateString()
    );
  } catch (error) {
    console.warn("Failed to read onboarding banner dismissal state:", error);
    return false;
  }
}

export function dismissOnboardingBannerForToday(userId: string): void {
  if (typeof window === "undefined" || !userId) return;
  try {
    window.localStorage.setItem(
      ONBOARDING_BANNER_DISMISSED_DATE_KEY_PREFIX + userId,
      todayDateString()
    );
  } catch (error) {
    console.warn("Failed to persist onboarding banner dismissal state:", error);
  }
}
